import { Vue, Component } from 'vue-property-decorator';
import {
  AppTheme, pageWithoutHeader, pageWithoutNavNames, pageWithScrollToTop,
} from '@/features/common/constants';
import { ThemeBackgroundType, getThemeBackground } from '../helpers/background';

@Component
export default class WhiteLabelMixin extends Vue {
  private AppTheme = AppTheme;

  get appTheme(): AppTheme {
    return this.$store.getters.getAppTheme;
  }

  get isDefaultTheme(): boolean {
    return this.appTheme === AppTheme.Default;
  }

  get themeClassName(): string {
    return `_${this.appTheme}`;
  }

  get themeBackground(): ThemeBackgroundType {
    return getThemeBackground(this.isDefaultTheme, this.appTheme);
  }

  get isPageWithoutNav(): boolean {
    return pageWithoutNavNames.includes(this.$route.name as string);
  }

  get isPageWithScrollToTop(): boolean {
    return pageWithScrollToTop.includes(this.$route.name as string);
  }

  get isPageHeader(): boolean {
    return !pageWithoutHeader.includes(this.$route.name as string);
  }
}
